import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { usefulLinksUrl } from 'SharedDir/backend/endpoints/useful-links';
import { UsefulLinks } from 'SharedDir/declarations/useful-links';

export default class UsefulLinksApiClass extends SimpleApi<
  UsefulLinks.UsefulLinksFull,
  UsefulLinks.UsefulLinksCreate,
  UsefulLinks.UsefulLinksCreate,
  UsefulLinks.UsefulLinksBare
> {
  constructor() {
    super(usefulLinksUrl);
  }
}
